import moment from 'moment';
import { usersData, daysToShow, weekDaysToShow, monthToShow, monthNameToShow } from './calendar.selectors';

export const calendar2InitialState = {
  calendar: {
    data: {},
    meta: {
      isLoading: false,
      hasError: false,
      loaded: false
    },
    filters: {
      startDate: moment().utc()
        .startOf('month')
        .hours(1),
      endDate: moment().utc(),
      teamLead: null,
    },
    selectors: {
      usersData,
      daysToShow,
      weekDaysToShow,
      monthToShow,
      monthNameToShow
    },
  }
};
